module.exports = __webpack_public_path__ + "static/media/hat.dc4bc1f6.png";